import type { Api } from '@pflegenavi/shared-frontend/platform';
import { get, getApiBaseUrl } from '@pflegenavi/shared-frontend/platform';
import type { Tenant } from '@pflegenavi/frontend/tenant';
import type { AuthenticationContext } from '@pflegenavi/frontend/authentication';
import type {
  LineItemConfigurationControllerResultTypes,
  CountriesTaxCodesControllerResultTypes,
} from '@pflegenavi/service-provider-shared/api-endpoints';
import {
  LineItemConfigurationControllerDefinition,
  CountriesTaxCodesControllerDefinition,
} from '@pflegenavi/service-provider-shared/api-endpoints';

export interface ILineItemTaxApi extends Api {
  getTaxCodesByCountry(dataIn: {
    params: {
      countryId: string;
    };
  }): Promise<CountriesTaxCodesControllerResultTypes['getTaxCodes']>;

  getAllCountries(
    dataIn: void
  ): Promise<CountriesTaxCodesControllerResultTypes['getCountries']>;

  getLineItemConfigurations(dataIn: {
    params: {
      globalServiceProviderId: string;
    };
  }): Promise<
    LineItemConfigurationControllerResultTypes['getLineItemConfigurations']
  >;
}

export class LineItemTaxApi implements ILineItemTaxApi {
  getTaxCodesByCountry: ILineItemTaxApi['getTaxCodesByCountry'];
  getAllCountries: ILineItemTaxApi['getAllCountries'];
  getLineItemConfigurations: ILineItemTaxApi['getLineItemConfigurations'];

  constructor(
    tenantId: Tenant,
    public authContext: AuthenticationContext,
    apiUrl?: string
  ) {
    this.getTaxCodesByCountry = get({
      authContext,
      url: (params) => {
        return `${getApiBaseUrl(tenantId, apiUrl)}/${
          CountriesTaxCodesControllerDefinition.controller
        }/${CountriesTaxCodesControllerDefinition.endpoints.getTaxCodes.url.replace(
          ':countryId',
          params.countryId
        )}`;
      },
    });

    this.getAllCountries = get({
      authContext,
      url: `${getApiBaseUrl(tenantId, apiUrl)}/${
        CountriesTaxCodesControllerDefinition.controller
      }/${CountriesTaxCodesControllerDefinition.endpoints.getCountries.url}`,
    });

    this.getLineItemConfigurations = get({
      authContext,
      url: (params) => {
        return `${getApiBaseUrl(
          tenantId,
          apiUrl
        )}/${LineItemConfigurationControllerDefinition.controller.replace(
          ':globalServiceProviderId',
          params.globalServiceProviderId
        )}/${
          LineItemConfigurationControllerDefinition.endpoints
            .getLineItemConfigurations.url
        }`;
      },
    });
  }
}
